import axios from "axios";

const getScanAgainstSuspendedData = ({
  brand_uuid,
  country,
  city_id,
  product_uuid,
  branch_uuid,
  category_uuid,
  model_uuid,
  period,
  start_date,
  end_date,
  url
}) => {
  let city = city_id;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        brand_uuid,
        category_uuid,
        country,
        product_uuid,
        city,
        branch_uuid,
        model_uuid,
        period,
        start_date,
        end_date,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error?.response?.data) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

export default getScanAgainstSuspendedData;
